import React, { FC } from 'react';
import { GetAllVosUploads_getAllVosUploads as VosInfo } from '../../../types/schemaTypes';
import { Loading } from '../../_common';
import DashboardVosItem from './DashboardVosItem';
import { ToastContainer, toast } from 'react-toastify';
import { toastOpt } from '../../../utils/helpers/toastHelper'

interface DashboardVosListProps {
    vos: VosInfo[];
    isLoading: boolean;
}

const downloadFormData = () => {
    toast.error('No Records available', toastOpt);
}

const DashboardVosList: FC<DashboardVosListProps> = ({
    vos,
    isLoading,
}: DashboardVosListProps): React.ReactElement => {

    if (isLoading) {
        return (
            <div className="VosList-Loading">
                <Loading />
            </div>
        );
    }

    return (
        <>
            <ToastContainer />
            {vos.map((vos, index) => (
                <DashboardVosItem key={index} index={index} vos={vos} downloadFormData={downloadFormData}></DashboardVosItem>
            ))}
        </>
    );
};

export default DashboardVosList;

